import { MentorsTable } from "../components/MentorsTable";
import MentorSearch from "../components/MentorSearch";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Button from "../components/UI/Button";
import { selectCurrentUser } from "../store/slices/authSlice";
import { useGetAllFamiliesQuery } from "../api/familyAPI";
import FamilySearch from "../components/FamilySearch";
import FamilyTable from "./FamilyTable";
import { Family } from "../../../shared/src/types/Family";
import { Link } from "react-router-dom";
import FamiliesMetThisMonth from "../components/FamiliesMetThisMonth";
import { CardSimple } from "../components/UI/Card";
import AddMentorButton from "../components/AddMentorButton";
import { useGetFamiliesAddedThisYearQuery } from "../api/familyAPI";

const AdminDashboard = () => {
  const user = useSelector(selectCurrentUser);
  const { data: families = [], isLoading } = useGetAllFamiliesQuery();
  const [filteredFamilies, setFilteredFamilies] = useState<Family[]>(families);
  const [showPopup, setShowPopup] = useState(false);
const { data: addedThisYearData, isLoading: loadingAddedThisYear } =
  useGetFamiliesAddedThisYearQuery();
    
  useEffect(() => {
    setFilteredFamilies(families);
  }, [families]);
  return (
    <div className="p-6 min-h-screen font-sans bg-background text-text-main text-right">
      <header className="text-center mb-10">
        <h1 className="text-3xl font-bold text-primary">שלום ל- {user?.name}</h1>
      </header>
      <div className="flex justify-end gap-4 mb-10">
        <Link to={`/profile/${user?.id}`}>
          <CardSimple className="w-full md:w-64 h-31.5 px-4 flex flex-col items-center justify-center gap-3 rounded-2xl shadow-card bg-white text-green-700 hover:bg-green-50 transition cursor-pointer text-center">
            <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5.121 17.804A13.937 13.937 0 0112 15c2.5 0 4.847.655 6.879 1.804M15 11a3 3 0 11-6 0 3 3 0 016 0zm6 1a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span className="font-semibold text-lg">אזור אישי</span>
          </CardSimple>
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-10 text-center">
        <div className="bg-white border border-border shadow-card rounded-xl h-80 flex flex-col items-center justify-center hover:bg-muted transition gap-3 p-4 text-text-main text-base font-semibold cursor-pointer">
          מספר המשפחות שהתווספו<br />מתחילת שנה
          {loadingAddedThisYear ? (
            <span>טוען...</span>
          ) : (
            <>
              <div className="text-2xl font-bold mb-2">{addedThisYearData?.count ?? 0}</div>
              משפחות חדשות השנה
            </>
          )}
        </div>
        <div className="bg-white border border-border shadow-card rounded-xl h-80 flex flex-col items-center justify-center hover:bg-muted transition gap-3 p-4 text-text-main text-base font-semibold cursor-pointer">
          כמה משפחות היו בלווי מתחילת שנה
        </div>
        <div className="bg-white border border-border shadow-card rounded-xl h-80 flex flex-col items-center justify-center hover:bg-muted transition gap-3 p-4 text-text-main text-base font-semibold cursor-pointer">
          רשימת משפחות שהתחילו החודש
        </div>
        <div className="bg-white border border-border shadow-card rounded-xl h-80 flex flex-col items-center justify-center hover:bg-muted transition gap-3 p-4 text-text-main text-base font-semibold cursor-pointer">
          <FamiliesMetThisMonth />
        </div>
      </div>
      <div className="mb-8 bg-background border border-border shadow-card rounded-xl p-4">
        <div className="flex flex-col gap-4 mb-4 sm:flex-row sm:justify-between sm:items-center">
          <h2 className="text-lg font-semibold">רשימת מלווים</h2>
          <div className="flex gap-2 flex-col sm:flex-row sm:items-center sm:ml-auto">
            <MentorSearch />
            <Button size="sm" onClick={() => setShowPopup(true)}>
              הוספת מלווה
            </Button>
          </div>
        </div>
          {showPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
              <button
                onClick={() => setShowPopup(false)}
                className="absolute top-2 left-2 text-gray-500 text-xl"
              >
                ×
              </button>
              <AddMentorButton />
            </div>
          </div>
        )}
        <MentorsTable />
      </div>
      <div className="mb-8 bg-background border border-border shadow-card rounded-xl p-4">
        <div className="flex flex-col gap-4 mb-4 sm:flex-row sm:justify-between sm:items-center">
          <h2 className="text-lg font-semibold">רשימת משפחות</h2>
          <div className="flex gap-2 flex-col sm:flex-row sm:items-center sm:ml-auto w-full sm:w-auto">
            <FamilySearch families={families} onSearchResultsChange={setFilteredFamilies} />
            <Button size="sm">יצירת משפחה חדשה</Button>
          </div>
        </div>
        {isLoading ? (
          <p className="text-center">טוען נתונים...</p>
        ) : filteredFamilies.length === 0 ? (
          <p className="text-center text-gray-500">לא נמצאו משפחות תואמות</p>
        ) : (
          <FamilyTable families={filteredFamilies} />
        )}
      </div>
    </div>
  );
};
export default AdminDashboard;